import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { AvailableDateRecord } from '../entities/records';
import * as selectors from '../entities/AvailableDate/selectors';

function mapStateToProps(state, { availableDateIds }) {
  return {
    availableDates: selectors.availableDatesByIds(state, availableDateIds),
  };
}

export default compose(
  setPropTypes({
    availableDateIds: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ])),
  }),
  connect,
  setPropTypes({
    availableDates: PropTypes.arrayOf(PropTypes.instanceOf(AvailableDateRecord)),
  }),
)(mapStateToProps);
